<template>
  <v-container class="pt-1">
    <v-layout row wrap>
      <v-flex xs12 lg10 offset-lg1 xl8 offset-xl2>
        <h3 class="headline mt-0 mb-3">Beliebteste <strong>Gewerke</strong></h3>
        <v-layout row wrap xjustify-center class="mb-3">
          <div v-for="(gewerk, index) in this.gewerke" :key="gewerk.id">
            <template v-if="index <= 9">
              <div class="text-truncate" v-if="gewerk.slug">
                <v-btn large outline :to="{ name: 'gewerkdetail', params: { id: gewerk.slug } }">
                  <h3 class="subheading text-none font-weight-medium">
                    {{ gewerk.name }}
                  </h3></v-btn
                >
              </div>
            </template>
          </div>
        </v-layout>
      </v-flex>
      <v-flex xs12 class="text-xs-center mt-2" v-if="this.gewerke.length > 0">
          <v-btn outline large xcolor="accent" class="title text-none" :to="{ name: 'gewerke' }">
            Alle Gewerke anzeigen
           <v-icon right dark>view_list</v-icon>
          </v-btn>
        </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  props: ['gewerke']
}
</script>

<style></style>
